import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FilterFieldGenerationParams } from '../../__base/generation';

export function generateDatetimeInputFilterField(
  params: FilterFieldGenerationParams<'datetimeInput'>,
): PartialPropsOf<'datetimeInput'> {
  if (params.fieldType === 'Date') {
    return applyPropsPatch(params.props, { content: { time: { enabled: false } } });
  }

  if (params.fieldType === 'Time') {
    return applyPropsPatch(params.props, {
      content: { date: { enabled: false }, time: { enabled: true } },
    });
  }

  return params.props;
}
